import { FundInvestorTagIcon } from '../../core/themes/icons/FundInvestorTagIcon';
import FundInvestorTagEdit from './FundInvestorTagEdit';
import FundInvestorTagList from './FundInvestorTagList';
import FundInvestorTagCreate from './FundInvestorTagCreate';

export default {
  list: FundInvestorTagList,
  create: FundInvestorTagCreate,
  edit: FundInvestorTagEdit,
  icon: FundInvestorTagIcon
};
